export const dateFormat = {
    DATE_FORMAT_1 : 'DD-MM-YYYY hh:mm A',
    DATE_FORMAT_2 : 'DD-MM-YYYY',
    DATE_FORMAT_3 : 'DD MMM YYYY', //26 Dec 2022, use Do for 26th
    DATE_FORMAT_4 : 'YYYY-MM-DD',
    TIME_FORMAT_1: 'hh:mm A',
    DATE_TIME_FORMAT_1: 'DD MMM YYYY hh:mm A' //6 Dec 2022 06:32 PM
}